/** Affichage : toujours l'heure de Paris, nombres à la française, « — » pour une valeur absente (jamais « 0 % » inventé). */
export const nombre = (n: number | null | undefined) => (n == null ? '—' : n.toLocaleString('fr-FR'));
export const pourcent = (n: number | null | undefined) => (n == null ? '—' : `${n.toLocaleString('fr-FR')} %`);
/** Date courte pour les tableaux : « 10/10 16:59 » (année seulement si ce n'est pas l'année en cours). */
export const dateCourte = (iso: string | null | undefined) => {
  if (!iso) return '—';
  const d = new Date(iso);
  const memeAnnee = d.getFullYear() === new Date().getFullYear();
  return d.toLocaleString('fr-FR', { timeZone: 'Europe/Paris', day: '2-digit', month: '2-digit', ...(memeAnnee ? {} : { year: '2-digit' }), hour: '2-digit', minute: '2-digit' });
};
export const dateHeure = (iso: string | null | undefined) =>
  iso ? new Date(iso).toLocaleString('fr-FR', { timeZone: 'Europe/Paris', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—';

/** Jour de Paris « AAAA-MM-JJ » décalé de n jours. */
export function jourParis(decalageJours = 0): string {
  const d = new Date(Date.now() + decalageJours * 86_400_000);
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit' }).format(d);
}

export type Preset = 'tout' | '7j' | '30j' | 'perso';
export function bornes(preset: Preset, du: string, au: string): { du: string | null; au: string | null } {
  if (preset === '7j') return { du: jourParis(-6), au: jourParis(0) };
  if (preset === '30j') return { du: jourParis(-29), au: jourParis(0) };
  if (preset === 'perso') return { du: du || null, au: au || null };
  return { du: null, au: null };
}
